export const titleFormat = /(^\w)|(?<=[\s-])\w/g;

export const emailCheck =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([a-z\d-]+\.)+[a-z]{2,})$/i;

export const nameCheck = /^[A-Za-z.\-'\s]+$/;
